export default "__VITE_ASSET__CuU7PezS__"